import { type WorklistOrderProcedureHallInfo } from '@/Models/GenericWorklist/WorklistResult';

interface HallCellProps {
    hallInfo: WorklistOrderProcedureHallInfo | undefined;
}

const HallCell = (props: HallCellProps): React.ReactElement => {
    const { hallInfo } = props;
    if (!hallInfo) {
        return (<span>Has no hall</span>);
    }

    const { Name } = hallInfo;
    return (<span>{Name}</span>);
};

export default HallCell;
